export const required = (value) => {
  return (
    typeof value === "string"
      ? value.trim()
      : typeof value === "number"
      ? !isNaN(value)
      : Array.isArray(value)
      ? value.length
      : value
  )
    ? undefined
    : "Campo Obligatorio";
};

export const composeValidators =
  (...validators) =>
  (value, allValues) =>
    validators.reduce(
      (error, validator) => error || validator(value, allValues),
      undefined
    );

export const validateEmail = (message) => (value) => {
  const error = "Correo Inválido";

  return value && !/^[A-Z0-9._%+-]+@[A-Z-0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? message || error
    : undefined;
};

export const phoneNumber = (message) => (value) => {
  const isOnlyNumbers = /^\d+$/.test(value);
  return !value || (isOnlyNumbers && value.length === 8)
    ? undefined
    : "Número inválido";
};

export const validateNIT = (value) => {
  if (!value) {
    return "NIT inválido";
  }

  const nitRegExp = /^[0-9]+(-?[0-9kK])?$/;

  if (!nitRegExp.test(value)) {
    return "NIT inválido";
  }

  value = value.replace(/-/, "");
  const lastChar = value.length - 1;
  const number = value.substring(0, lastChar);
  const expectedChecker = value.substring(lastChar, lastChar + 1).toLowerCase();

  let factor = number.length + 1;
  let total = 0;

  for (let i = 0; i < number.length; i++) {
    const character = number.substring(i, i + 1);
    const digit = parseInt(character, 10);

    total += digit * factor;
    factor = factor - 1;
  }

  const modulus = (11 - (total % 11)) % 11;
  const computedChecker = modulus === 10 ? "k" : modulus.toString();

  if (expectedChecker !== computedChecker) {
    return "NIT inválido";
  }

  return undefined;
};

export const onlyText = (message) => (value) => {
  const isOnlyText = /^[A-Za-z_ ]+$/.test(value);

  if (!isOnlyText) {
    return message || "Campo Inválido";
  }
};

export const onlyNumbers = (message) => (value) => {
  const isOnlyNumbers = /^\d+$/.test(value);
  return !value || isOnlyNumbers ? undefined : "Número inválido";
};

export const validateCvv = (value) => {
  if (value === "000" || value.toString().length !== 3) {
    return "Ingresa un CVV válido";
  }
};

export const minLength = (message, min) => (value) => {
  if (value.length < min) {
    return `Valor del campo muy corto (min ${min} caracteres)`;
  }
};

export const exactLength = (message, valLength) => (value) => {
  if (value.length !== valLength) {
    return `Error en el campo (${valLength} caracteres)`;
  }
};

export const cardLength = (message) => (value) => {
  if (value.length < 16 || value.length > 17) {
    return `Error en el campo (16 ó 17 caracteres)`;
  }
};

export const validateExpirationDate = (value) => {
  if (!value || !/^\d{2}\/\d{2}$/.test(value)) {
    return "Formato MM/AA requerido";
  }

  const [month, year] = value.split("/");
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);

  if (monthNum < 1 || monthNum > 12) {
    return "Mes inválido (01-12)";
  }

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() % 100;
  const currentMonth = currentDate.getMonth() + 1;

  if (
    yearNum < currentYear ||
    (yearNum === currentYear && monthNum < currentMonth)
  ) {
    return "Fecha de expiración inválida";
  }

  return undefined;
};
